'use strict';
module.exports = function(app) {
    require('./js/service/front_end.service.js')(app);
    require('./js/factory/bidding_rate_increase.factory.js')(app);
    require('./js/factory/sync_display_product.factory.js')(app);
    require('./js/filter/language.filter.js')(app);
};



/*****************
 ** WEBPACK FOOTER
 ** ./shared/index.js
 ** module id = 80
 ** module chunks = 0
 **/